import { Card, CardBody } from 'react-bootstrap'
import { Esportazione } from '../../types'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { orderBy } from 'lodash'

export default function CardStoricoEsportazione({
  esportazione,
}: {
  esportazione: Esportazione | undefined
}) {
  return (
    <Card className="mt-3 mb-5">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              <span className="material-icons text-secondary me-2">
                history
              </span>
              Storico
            </h4>
          </div>
        </div>
        <div className="mt-3">
          {orderBy(esportazione?.logs, ['data_ora'], ['desc'])?.map((storia) => (
            <div key={storia.id} className="mt-3 border-bottom pb-3">
              <div className="p-sm">
                {dayjs(storia.data_ora).format('DD.MM.YYYY')} -{' '}
                {dayjs(storia.data_ora).format('HH:mm')}
              </div>
              <div className="mt-2">
                <span className="p-md me-1 text-black">
                  {storia.user_fullname}
                </span>
                {storia.stato === 'creata' && (
                  <span className="p-md text-body-secondary me-1">
                    ha creato l'esportazione.
                  </span>
                )}
                {storia.stato === 'esportata' && (
                  <span className="p-md text-body-secondary me-1">
                    ha scaricato il file di esportazione.
                  </span>
                )}
                {storia.stato === 'trasmessa' && (
                  <span className="p-md text-body-secondary me-1">
                    ha trasmesso il file a telemaco.
                  </span>
                )}
              </div>
              <div>
                <span className="p-md text-body-secondary me-1">
                  Stato esportazione:
                </span>
                <span
                  className={classNames(
                    'badge badge-state-all text-capitalize'
                  )}
                >
                  {storia.stato}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}
